export default __webpack_public_path__ + "static/media/icon-x.80c231f8.svg";